export const heroSlider = () => {
  const heroEl = document.getElementById('heroSlider');
  if (!heroEl) return;
  // arrowPath: chevron-right scaled to Splide's 40×40 viewBox (original 24×24 × 1.667)
  const splide = new Splide('.splide--hero', {
    type: 'fade',
    rewind: true,
    autoplay: true,
    interval: 5000,
    speed: 800,
    pauseOnHover: false,
    arrows: true,
    pagination: true,
    arrowPath: 'M15 30L25 20L15 10',
  });
  splide.mount();
};

export const upSellProductsSlider = () => {
  const upSellProducts = document.getElementById("upsellSlider");
  if (upSellProducts) {
    const splide = new Splide(".splide--product-upsell", {
      type: "slide",
      perPage: 3,
      perMove: 1,
      drag: true,
      rewind: true,
      pagination: false,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
};

export const relatedProductsSlider = () => {
  const relatedProducts = document.getElementById("relatedProducts");
  if (relatedProducts) {
    const splide = new Splide(".splide--related-products", {
      type: "slide",
      perPage: 3,
      perMove: 1,
      drag: true,
      rewind: true,
      pagination: false,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();

    const list = relatedProducts.querySelector('.splide__list');
    if (list) list.style.transform = 'translateX(0)';
  }
};

export const productGallerySlider = () => {
  const galleryEl = document.getElementById('productGallery');
  if (!galleryEl) return;
  const slides = galleryEl.querySelectorAll('.splide__slide');
  const hasMultiple = slides.length > 1;
  const splide = new Splide('.splide--product-gallery', {
    type: 'slide',
    perPage: 1,
    perMove: 1,
    drag: hasMultiple,
    rewind: hasMultiple,
    pagination: false,
    arrows: hasMultiple,
    gap: '0',
  });
  splide.mount();
};

export const TrustedBySlider = () => {
  const trustedBy = document.getElementById("trustedBy");
  if (trustedBy) {
    const splide = new Splide(".splide-trusted-by", {
      type: "loop",
      perPage: 7,
      perMove: 1,
      drag: false,
      arrows: false,
      pagination: false,
      gap: "32px",
      autoplay: true,
      interval: 0,
      speed: 60000,
      easing: "linear",
      pauseOnHover: false,
      pauseOnFocus: false,
      resetProgress: false,
      breakpoints: {
        1200: {
          perPage: 7,
        },
        991: {
          perPage: 6,
        },
        576: {
          perPage: 3,
        },
      },
    });
    splide.mount();
  }
};
